import * as types from './constant';
import {parseDataFromLocalStorage} from './helper';
import PersistenceService from 'service/PersistenceService';
import {persistanceKeys} from './persistanceKeys';
import _ from "lodash";

export function enableLocalStoragePersistenceMiddleware() {
  return { type: types.ENABLE_PERSISTENCE_MIDDLEWARE, payload: {}};
}

export const loadReduxStoreFromLocalStorage = () => {

  return new Promise((resolve, reject) => {
      let localStorageState = {};
      let promiseCollector = [];
      for(const persistanceItem of persistanceKeys) {

          let loadAction = PersistenceService.getItem('redux_persistence__'+persistanceItem.path.join("_"))
                          .then( data => {

                              if(data && data !== "") {
                                  let target = localStorageState;
                                  for (let i = 0; i < persistanceItem.path.length; i++) {
                                      const pathItem = persistanceItem.path[i];
                                      if (i == persistanceItem.path.length - 1) {
                                          target[pathItem] = parseDataFromLocalStorage(data);
                                      } else {
                                          if (!(pathItem in target)) {
                                              target[pathItem] = {};
                                          }
                                          target = target[pathItem];
                                      }
                                  }
                              }

                          })
                          .catch((e)=>{
                              console.error("error", e)
                          });

          promiseCollector.push(loadAction);
      }

      Promise.all(promiseCollector).then(() => {
          console.log("localStorageState",localStorageState)
          if(_.size(localStorageState) > 0){
              resolve({
                  type : types.LOAD_REDUX_STORE_FROM_LOCAL_STORAGE,
                  payload : {
                      localStorageState : localStorageState
                  }
              });
          }else{
              resolve({
                  type : types.LOAD_REDUX_STORE_FROM_LOCAL_STORAGE_CANCEL,
              });
          }
      });

  });
}




// WEBPACK FOOTER //
// ./src/storeState/persistence/action.js